<div>
  <mat-label>目標温度設定</mat-label>
</div><br>
<form #form="ngForm">
  <mat-form-field class="input-margin" style="width: 40%; margin-right: 10%">
    <mat-label>
      開始日齢
    </mat-label>
    <input matInput required
           placeholder="開始日齢"
           type="number"
           min="1"
           name="startNichirei"
           [(ngModel)]="meisai.startNichirei">
  </mat-form-field>
  <br>
  <mat-form-field class="input-margin" style="width: 40%; margin-right: 10%">
    <mat-label>
      最低温度
    </mat-label>
    <input matInput
           placeholder="最低温度"
           type="number"
           name="lowTempreture"
           [(ngModel)]="meisai.lowTemperature">
  </mat-form-field>

  <mat-form-field class="input-margin" style="width: 40%">
    <mat-label>
      最高温度
    </mat-label>
    <input matInput
           placeholder="最高温度"
           type="number"
           name="highTempreture"
           [(ngModel)]="meisai.highTemperature">
  </mat-form-field>
</form>
<div mat-dialog-actions align="end">
  <button mat-button
          mat-flat-button
          color="primary"
          (click)="register()"
          [disabled]="form.invalid || !form.dirty">
    <span>Enter</span>
  </button>
</div>

